(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tph-artwork-guidelines"] && !Shopify.designMode) return;
  try {
    
(()=>{const refresh=()=>{const y=new Intl.DateTimeFormat('en-IE',{year:'numeric',timeZone:'Europe/Dublin'}).format(new Date());document.querySelectorAll('[data-tph-year]').forEach(el=>el.textContent=y)};refresh();setInterval(refresh,60000);document.addEventListener('visibilitychange',refresh)})();

document.querySelectorAll('[data-tph-home]').forEach(function(home){
 if(home.dataset.tphReady)return;home.dataset.tphReady='true';
 home.addEventListener('click',function(event){
  var opener=event.target.closest('[data-tph-open]');if(opener){home.querySelector('#'+opener.dataset.tphOpen).showModal();return;}
  var closer=event.target.closest('[data-tph-close]');if(closer){closer.closest('dialog').close();return;}
  var quote=event.target.closest('[data-tph-quote]');var help=event.target.closest('[data-tph-help]');
  if(quote||help){var title=quote?quote.dataset.tphQuote:help.dataset.tphHelp;var dialog=home.querySelector('#tph-quote');var heading=dialog.querySelector('[data-tph-quote-heading]');if(!heading.dataset.original)heading.dataset.original=heading.textContent;heading.textContent=title||heading.dataset.original;dialog.querySelector('textarea').value=title?'Enquiry: '+title+'\n\n':'';dialog.showModal();}
 });
 home.querySelectorAll('dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog){var rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});});
 if(new URLSearchParams(location.search).get('contact_posted')==='true'||home.querySelector('.errors'))home.querySelector('#tph-quote').showModal();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tph-delivery-information"] && !Shopify.designMode) return;
  try {
    
(()=>{const refresh=()=>{const y=new Intl.DateTimeFormat('en-IE',{year:'numeric',timeZone:'Europe/Dublin'}).format(new Date());document.querySelectorAll('[data-tph-year]').forEach(el=>el.textContent=y)};refresh();setInterval(refresh,60000);document.addEventListener('visibilitychange',refresh)})();

document.querySelectorAll('[data-tph-home]').forEach(function(home){
 if(home.dataset.tphReady)return;home.dataset.tphReady='true';
 home.addEventListener('click',function(event){
  var opener=event.target.closest('[data-tph-open]');if(opener){home.querySelector('#'+opener.dataset.tphOpen).showModal();return;}
  var closer=event.target.closest('[data-tph-close]');if(closer){closer.closest('dialog').close();return;}
  var quote=event.target.closest('[data-tph-quote]');var help=event.target.closest('[data-tph-help]');
  if(quote||help){var title=quote?quote.dataset.tphQuote:help.dataset.tphHelp;var dialog=home.querySelector('#tph-quote');var heading=dialog.querySelector('[data-tph-quote-heading]');if(!heading.dataset.original)heading.dataset.original=heading.textContent;heading.textContent=title||heading.dataset.original;dialog.querySelector('textarea').value=title?'Enquiry: '+title+'\n\n':'';dialog.showModal();}
 });
 home.querySelectorAll('dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog){var rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});});
 if(new URLSearchParams(location.search).get('contact_posted')==='true'||home.querySelector('.errors'))home.querySelector('#tph-quote').showModal();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tph-homepage"] && !Shopify.designMode) return;
  try {
    
(()=>{const refresh=()=>{const y=new Intl.DateTimeFormat('en-IE',{year:'numeric',timeZone:'Europe/Dublin'}).format(new Date());document.querySelectorAll('[data-tph-year]').forEach(el=>el.textContent=y)};refresh();setInterval(refresh,60000);document.addEventListener('visibilitychange',refresh)})();

document.querySelectorAll('[data-tph-home]').forEach(function(home){
 if(home.dataset.tphReady)return;home.dataset.tphReady='true';
 home.addEventListener('click',function(event){
  var opener=event.target.closest('[data-tph-open]');if(opener){home.querySelector('#'+opener.dataset.tphOpen).showModal();return;}
  var closer=event.target.closest('[data-tph-close]');if(closer){closer.closest('dialog').close();return;}
  var quote=event.target.closest('[data-tph-quote]');var help=event.target.closest('[data-tph-help]');
  if(quote||help){var title=quote?quote.dataset.tphQuote:help.dataset.tphHelp;var dialog=home.querySelector('#tph-quote');var heading=dialog.querySelector('[data-tph-quote-heading]');if(!heading.dataset.original)heading.dataset.original=heading.textContent;heading.textContent=title||heading.dataset.original;dialog.querySelector('textarea').value=title?'Enquiry: '+title+'\n\n':'';dialog.showModal();}
 });
 home.querySelectorAll('dialog').forEach(function(dialog){dialog.addEventListener('click',function(event){if(event.target===dialog){var rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});});
 if(new URLSearchParams(location.search).get('contact_posted')==='true'||home.querySelector('.errors'))home.querySelector('#tph-quote').showModal();
});


  } catch(e) { console.error(e); }
})();
})();
